import { Link } from "react-router-dom";
import { Heart, ShoppingBag, Trash2 } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { imgUrl, formatINR } from "../lib/api";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";

export default function WishlistPage() {
  const { wishlist, toggleWishlist, addToCart } = useStore();

  if (wishlist.length === 0) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-28 text-center" data-testid="wishlist-empty">
        <Seo title="Wishlist — Anaya Fashion & Gifts" path="/wishlist" noindex />
        <Heart className="mx-auto text-primary/40" size={48} />
        <h1 className="mt-4 font-display text-4xl">No saved pieces yet</h1>
        <p className="mt-3 text-sm font-light text-muted-foreground">Tap the heart on anything you love.</p>
        <Link to="/shop" data-testid="wishlist-shop-link" className="mt-6 inline-block rounded-full bg-foreground px-7 py-3 text-xs tracking-[0.2em] text-white uppercase hover:bg-primary">Browse the boutique</Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6" data-testid="wishlist-page">
      <Seo title="Wishlist — Anaya Fashion & Gifts" path="/wishlist" noindex />
      <Reveal>
        <p className="text-[11px] tracking-[0.4em] text-primary uppercase">Saved for later</p>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl">Your wishlist</h1>
      </Reveal>
      <div className="mt-10 grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-3 lg:grid-cols-4" data-testid="wishlist-grid">
        {wishlist.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.06}>
            <div className="group" data-testid={`wishlist-item-${p.id}`}>
              <div className="relative overflow-hidden rounded-[1.25rem] bg-white shadow-sm">
                <Link to={`/product/${p.id}`}>
                  <div className="aspect-[3/4] overflow-hidden bg-secondary/40">
                    {p.image ? <img src={imgUrl(p.image)} alt={p.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      : <div className="flex h-full items-center justify-center font-display text-4xl text-primary/40">A</div>}
                  </div>
                </Link>
                <button data-testid={`wishlist-remove-${p.id}`} onClick={() => toggleWishlist(p)} aria-label="Remove from wishlist"
                  className="absolute right-3 top-3 rounded-full bg-white/85 p-2 shadow-md hover:bg-secondary"><Trash2 size={14} /></button>
              </div>
              <div className="px-1 pt-3">
                <Link to={`/product/${p.id}`}><h3 className="font-display text-sm sm:text-base">{p.name}</h3></Link>
                <div className="mt-1 flex items-center justify-between">
                  <span className="text-sm font-medium text-primary">{formatINR(p.price)}</span>
                  <button data-testid={`wishlist-add-${p.id}`} onClick={() => addToCart({ id: p.id, name: p.name, price: p.price, images: [p.image] }, 1)}
                    className="flex items-center gap-1 rounded-full bg-foreground/85 px-3 py-1.5 text-[10px] tracking-widest text-white uppercase hover:bg-primary">
                    <ShoppingBag size={11} /> Add
                  </button>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
